module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0011.80d1abc5.jpg";